module.exports = __webpack_public_path__ + "static/media/clients.4cd33212.png";